var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoinStack = function SvgCoinStack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D2939",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75,
    d: "M14.176 4.222C14.176 2.994 11.673 2 8.587 2S3.002 2.996 3 4.222m0 0C3 5.45 5.501 6.444 8.588 6.444s5.589-.994 5.589-2.222v8.623M3 4.222v13.334c.001 1.227 2.502 2.222 5.588 2.222 1.497 0 2.848-.237 3.85-.618M3.002 8.667c0 1.228 2.501 2.222 5.588 2.222s5.589-.994 5.589-2.222m-1.672 6.028c-1.008.394-2.391.639-3.918.639-3.086 0-5.587-.995-5.587-2.223m17.526.354a4.98 4.98 0 0 1 0 7.07 5.05 5.05 0 0 1-7.113 0 4.98 4.98 0 0 1 0-7.07 5.05 5.05 0 0 1 7.113 0"
  })));
};
export default SvgCoinStack;